import React from 'react'
import { useStateContext } from '@zambezi/caballo-vivo'

import PayMeYouLinkCard from './PayMeYouLinkCard'
import ConsentListSectionHeader from './ConsentListSectionHeader'
import LinkGroup from './LinkGroup'

import style from './PayMe.module.css'

export default function PayMe() {
  const groupedLink = useStateContext().getIn([
    'paymeyou',
    'payMeLinks',
    'linksByFriendlyGroup',
  ])
  const reusableLinks = useStateContext().getIn([
    'paymeyou',
    'payMeReusableLinks',
    'links',
  ])

  return (
    <section>
      <div className={style.group}>
        <ConsentListSectionHeader
          count={reusableLinks.size}
          label={'Reusable payment links'}
          description={
            'Payment links/ QR codes do not expire. Cancel by reviewing each link.'
          }
          consentType="payMeYou"
          pointedBorder
          indented
        />
        {reusableLinks.map((link, index) => {
          return (
            <PayMeYouLinkCard key={link.get('id')} link={link} index={index} />
          )
        })}
      </div>
      <LinkGroup
        groupedLinkData={groupedLink}
        description={
          'Links expire after 5 days. QR codes expire after 5 minutes. Cancel by reviewing each link.'
        }
      />
    </section>
  )
}
